// CTSK-514 — the /notes toolbar: order (Manual / Sorted), sort key + direction,
// and grid type. Choices are saved per user (note_prefs) by the caller.

import { NOTE_GRID_TYPES, type NoteGridType, type NotePrefs } from '@captain-tasko/shared';
import './notes.css';

const GRID_LABEL: Record<NoteGridType, string> = { masonry: 'Masonry', grid: 'Grid', list: 'List' };
const SORT_LABEL: Record<NotePrefs['sortKey'], string> = {
  updated: 'Last updated',
  created: 'Created',
  color: 'Colour',
  title: 'First line',
};

export function NotesToolbar({ prefs, onChange }: { prefs: NotePrefs; onChange: (patch: Partial<NotePrefs>) => void }) {
  return (
    <div className="notes-toolbar" role="toolbar" aria-label="Notes view">
      <div className="notes-toolbar__group">
        <span id="notes-order-label">Order</span>
        <div className="notes-toolbar__seg" role="group" aria-labelledby="notes-order-label">
          <button type="button" aria-pressed={prefs.orderMode === 'manual'} onClick={() => onChange({ orderMode: 'manual' })}>
            Manual
          </button>
          <button type="button" aria-pressed={prefs.orderMode === 'sorted'} onClick={() => onChange({ orderMode: 'sorted' })}>
            Sorted
          </button>
        </div>
      </div>
      {prefs.orderMode === 'sorted' && (
        <div className="notes-toolbar__group">
          <label>
            Sort by{' '}
            <select aria-label="Sort by" value={prefs.sortKey} onChange={(e) => onChange({ sortKey: e.target.value as NotePrefs['sortKey'] })}>
              {(Object.keys(SORT_LABEL) as Array<NotePrefs['sortKey']>).map((k) => (
                <option key={k} value={k}>{SORT_LABEL[k]}</option>
              ))}
            </select>
          </label>
          <select aria-label="Direction" value={prefs.sortDir} onChange={(e) => onChange({ sortDir: e.target.value as NotePrefs['sortDir'] })}>
            <option value="desc">Descending</option>
            <option value="asc">Ascending</option>
          </select>
        </div>
      )}
      <div className="notes-toolbar__group">
        <span id="notes-grid-label">Layout</span>
        <div className="notes-toolbar__seg" role="group" aria-labelledby="notes-grid-label">
          {NOTE_GRID_TYPES.map((g) => (
            <button key={g} type="button" aria-pressed={prefs.gridType === g} onClick={() => onChange({ gridType: g })}>
              {GRID_LABEL[g]}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
